import { render } from "./VirtualRedTagMethodIcon.vue?vue&type=template&id=3be1cca6&scoped=true&ts=true"
import script from "./VirtualRedTagMethodIcon.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagMethodIcon.vue?vue&type=script&lang=ts"

import "./VirtualRedTagMethodIcon.vue?vue&type=style&index=0&id=3be1cca6&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be1cca6"]])

export default __exports__